<template>
  <div
    class="sorting-checklist-question"
    :class="{ 'sorting-checklist-question--has-right': $scopedSlots.right }"
  >
    <div class="sorting-checklist-question_left">
      <div class="title">
        <p class="num">
          {{ quesNum }}
        </p>
      </div>
      <div class="question-title">
        <p class="question-title_title">
          {{ title }}
        </p>
        <p
          v-if="subtitle"
          class="question-title_subtitle"
        >
          {{ subtitle }}
        </p>
      </div>
    </div>
    <div v-if="$scopedSlots.right" class="sorting-checklist-question__extra">
      <slot name="right" />
    </div>
    <div class="sorting-checklist-question_right">
      <i class="icon-drag sorting-checklist-question_right-icon" />
    </div>
  </div>
</template>
<script>
export default {
  name: "SortingChecklistQuestion",
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    quesNum: {
      type: [Number, String],
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/sorting-checklist-question";
</style>